import React from 'react';
import { BarChart3, TrendingUp, Info, Mail, Sparkles, HardDrive } from 'lucide-react';

const TabNavigation = ({ activeTab, setActiveTab }) => {
  const getTabClassName = (tabName) => {
    const isActive = activeTab === tabName;
    return `flex items-center px-4 md:px-5 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 whitespace-nowrap flex-shrink-0 border-b-2 ${isActive
      ? 'bg-white shadow-sm'
      : 'border-transparent hover:bg-gray-200'
      }`;
  };

  const getTabStyle = (tabName) => {
    const isActive = activeTab === tabName;
    return {
      color: isActive ? 'var(--accent-primary)' : 'var(--accent-text-subtle)',
      borderBottomColor: isActive ? 'var(--accent-primary)' : undefined,
    };
  };

  return (
    <div className="mb-8">
      <nav
        className="flex space-x-2 p-1.5 pl-4 pr-4 rounded-xl overflow-x-auto overflow-y-visible scrollbar-hide md:px-4"
        style={{ background: 'var(--bg-secondary)' }}
      >
        <button
          onClick={() => setActiveTab('home')}
          className={getTabClassName('home')}
          style={getTabStyle('home')}
          data-tour-id="nav-home"
        >
          <BarChart3 className="h-4 w-4 mr-2 flex-shrink-0" />
          <span className="hidden sm:inline">Home</span>
        </button>
        <button
          onClick={() => setActiveTab('trends')}
          className={getTabClassName('trends')}
          style={getTabStyle('trends')}
          data-tour-id="nav-trends"
        >
          <TrendingUp className="h-4 w-4 mr-2 flex-shrink-0" />
          <span className="hidden sm:inline">Trends</span>
        </button>
        <button
          onClick={() => setActiveTab('predictions')}
          className={getTabClassName('predictions')}
          style={getTabStyle('predictions')}
          data-tour-id="nav-predictions"
        >
          <Sparkles className="h-4 w-4 mr-2 flex-shrink-0" />
          <span className="hidden sm:inline">Predictions</span>
        </button>
        <button
          onClick={() => setActiveTab('storage')}
          className={getTabClassName('storage')}
          style={getTabStyle('storage')}
          data-tour-id="nav-storage"
        >
          <HardDrive className="h-4 w-4 mr-2 flex-shrink-0" />
          <span className="hidden sm:inline">Storage</span>
        </button>
        <button
          onClick={() => setActiveTab('about')}
          className={getTabClassName('about')}
          style={getTabStyle('about')}
        >
          <Info className="h-4 w-4 mr-2 flex-shrink-0" />
          <span className="hidden sm:inline">About</span>
        </button>
        <button
          onClick={() => setActiveTab('contact')}
          className={getTabClassName('contact')}
          style={getTabStyle('contact')}
        >
          <Mail className="h-4 w-4 mr-2 flex-shrink-0" />
          <span className="hidden sm:inline">Contact</span>
        </button>
      </nav>
    </div>
  );
};

export default TabNavigation;
